import SetDetails from '@/components/booking-manager/artist/advance-step/review-set/SetDetails.vue'

export default {
    components: {
        SetDetails
    },
    props: {
        set: {
            required: false,
            type: Object,
            default: null
        },
        mode: {
            required: false,
            type: String,
            default: null
        },
        btnFns: {
            required: false,
            type: Object,
            default: null
        }
    }
}
